import { clsx } from 'clsx'
import {
  AE, AU, BH, BR, CA, CH, CN, DK, DZ, EG, EU, GB, HK, ID, IN, IQ, JO, JP, KR, KW, LY, MA, MX, MY,
  NO, NZ, OM, PK, PL, QA, RU, SA, SE, SG, TH, TN, TR, US, YE, ZA,
} from 'country-flag-icons/react/1x1'
import { getCurrency } from '@globalx/core'

type Flag = typeof US

const FLAGS: Record<string, Flag> = {
  AE, AU, BH, BR, CA, CH, CN, DK, DZ, EG, EU, GB, HK, ID, IN, IQ, JO, JP, KR, KW, LY, MA, MX, MY,
  NO, NZ, OM, PK, PL, QA, RU, SA, SE, SG, TH, TN, TR, US, YE, ZA,
}

export function CurrencyFlag({ code, className }: { code: string; className?: string }) {
  const region = getCurrency(code)?.region
  const Flag = region ? FLAGS[region] : undefined
  return (
    <span
      className={clsx(
        'relative inline-flex shrink-0 overflow-hidden rounded-full bg-surface-3 ring-1 ring-line-strong',
        className ?? 'size-9',
      )}
      aria-hidden
    >
      {Flag ? (
        <Flag className="size-full object-cover" />
      ) : (
        <span className="m-auto text-[0.6rem] font-semibold text-muted">{code.slice(0, 2)}</span>
      )}
    </span>
  )
}
